var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#E88D22",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.658 7.95333C14.8637 8.07084 15.0341 8.24128 15.1516 8.44694L20.825 18.3753C21.1885 19.0114 20.9675 19.8217 20.3314 20.1852C20.1309 20.2997 19.9041 20.36 19.6732 20.36H8.32653C7.59391 20.36 7 19.7661 7 19.0334C7 18.8026 7.06024 18.5757 7.17478 18.3753L12.8481 8.44694C13.2116 7.81084 14.0219 7.58984 14.658 7.95333ZM13.9643 16.235C13.4905 16.235 13.1352 16.5852 13.1352 17.0521C13.1352 17.5403 13.4798 17.8905 13.9643 17.8905C14.4381 17.8905 14.7934 17.5403 14.7934 17.0627C14.7934 16.5852 14.4381 16.235 13.9643 16.235ZM14.6276 11.0947H13.301V15.0743H14.6276V11.0947Z",
    fill: "#E88D22"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusAlertIcon);
export default __webpack_public_path__ + "static/media/StatusAlertIcon.301ed6d1b8726cddd48a9336718cde0b.svg";
export { ForwardRef as ReactComponent };